import { useState } from "react";
import { api } from "../utils/axios-config";

export const integerNumberOrEmpty = /^\d*$/;
export const egyptianPhoneNumberRegex = /^(01[0,1,2,5])\d{8}$/;

const GetPhone = ({ setShowOTP, phone, setPhone }) => {
  const [errorMsg, setErrorMsg] = useState("");

  const handlePhoneChange = (e) => {
    const phoneValue = e.target.value;
    //
    setErrorMsg("");
    if (!integerNumberOrEmpty.test(phoneValue)) return;
    setPhone(phoneValue);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!egyptianPhoneNumberRegex.test(phone)) {
      setErrorMsg(
        "Invalid phone number. Please enter valid 11 digit number starting with 010, 011, 012, 015"
      );
      return;
    } else {
      try {
        let requestOTPRes = await api.post(
          `/users/deactivate-account/request`,
          {
            phone: `+2${phone}`,
          }
        );
        if (requestOTPRes.status === 200) {
          setShowOTP(true);
        } else {
          setErrorMsg(requestOTPRes?.data?.message);
        }
      } catch (error) {
        if (error?.response?.data?.message)
          setErrorMsg(error?.response?.data?.message);
        else setErrorMsg(error?.response?.data?.msg);
      }
    }
  };

  return (
    <div className="get-phone-box">
      <div className="container">
        <img src="/bro-en.svg" alt="logo" className="logo" />
        <form onSubmit={handleSubmit}>
          <input
            type="text"
            placeholder="Mobile Number"
            className="input-phone"
            onChange={handlePhoneChange}
            value={phone}
          />
          <button onClick={handleSubmit} className="btn-submit">
            Next
          </button>
          {errorMsg && <p className="error-msg">{errorMsg}</p>}
        </form>
      </div>
    </div>
  );
};

export default GetPhone;
